import React from "react";
import { motion } from "framer-motion";
import { MdLogout, MdClose } from "react-icons/md";

const LogoutConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 overflow-hidden"
      >
        {/* Header */}
        <div className="bg-gray-50 px-6 py-4 flex items-center justify-between border-b">
          <div className="flex items-center gap-2">
            <MdLogout className="text-red-500 text-xl" />
            <h3 className="text-lg font-semibold text-gray-800">Confirm Logout</h3>
          </div>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <MdClose className="text-xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600 mb-6">
            Are you sure you want to logout from your account?
          </p>
          
          {/* Actions */}
          <div className="flex items-center justify-end gap-3 mt-6">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onClose}
              className="px-5 py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors text-gray-700 font-medium"
            >
              Cancel
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onConfirm}
              className="px-5 py-2 bg-primeColor text-white rounded-md hover:bg-opacity-90 transition-colors font-medium flex items-center gap-2"
            >
              <MdLogout />
              Logout
            </motion.button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LogoutConfirmationModal;